import {useRef, useState} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {LeftPageHeader, PageHeader} from 'Components/Public/PageHeader/PageHeader';
import { data } from './NursingHomeData';
import {IconTextButton, TextButton} from "../../../Components/Button";
import {ICONS} from "../../../Utils/icons";
import {httpDownload} from "../../../Utils/httpDownload";
import {useSelector} from "react-redux";
import {setGlobalErrorStatus} from "../../../Components/StatusHandling";
import {ERROR_MESSAGES} from "../../../Utils/constants";
import { useDispatch } from 'react-redux';
import {Card} from "react-bootstrap";
import CommonFormatsBody from "../../../Components/Public/CommonFormats/CommonFormatsBody";
import Feedback from "../../../Components/Public/Feedback/Feedback";

function NursingHomeV1_0() {
  const sectionRefs = useRef({});
  const allResourceGroupId = 2846;
  const COLLECT_DATA_ALL_RESOURCE_GROUPID = 2847;
  const SUBMIT_DATA_ALL_RESOURCE_GROUPID = 2848;
  
  const loginInfo = useSelector(state => state.loginInfo);
  const [isAllDownloading, setIsAllDownloading] = useState(false);
  const [isCollectDownloading, setIsCollectDownloading] = useState(false);
  const [isSubmitDownloading, setIsSubmitDownloading] = useState(false);
  const dispatch = useDispatch();
  
  const scrollTo = (key) => {
    sectionRefs.current[key]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  
  const handleAllFileDownload = async () => {
    if(!isAllDownloading) {
      setIsAllDownloading(true);
      const res = await getDocumentDownloadCall(allResourceGroupId);
      
      
      if (res) {
        //console.log("handleFileDownload", res);
        // get filename from the res content-disposition
        const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
        //console.log("handleFileDownload", filename)
        let url = window.URL.createObjectURL(res.data);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.GENERAL_ERROR.title,
            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        })
      }
      setTimeout(() => {
        //console.log("after file download");
        setIsAllDownloading(false);
      }, 1000);
    }
  }
  
  const handleSubmitFileDownload = async (groupId) => {
    if(!isSubmitDownloading) {
      setIsSubmitDownloading(true);
      const res = await getDocumentDownloadCall(SUBMIT_DATA_ALL_RESOURCE_GROUPID);
      
      
      if (res) {
        //console.log("handleFileDownload", res);
        // get filename from the res content-disposition
        const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
        //console.log("handleFileDownload", filename)
        let url = window.URL.createObjectURL(res.data);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.GENERAL_ERROR.title,
            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        })
      }
      setTimeout(() => {
        //console.log("after file download");
        setIsSubmitDownloading(false);
      }, 1000);
    }
  }
  
  const handleCollectFileDownload = async () => {
    if(!isCollectDownloading) {
      setIsCollectDownloading(true);
      const res = await getDocumentDownloadCall(COLLECT_DATA_ALL_RESOURCE_GROUPID);
      
      
      if (res) {
        //console.log("handleFileDownload", res);
        // get filename from the res content-disposition
        const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
        //console.log("handleFileDownload", filename)
        let url = window.URL.createObjectURL(res.data);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.GENERAL_ERROR.title,
            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        })
      }
      setTimeout(() => {
        //console.log("after file download");
        setIsCollectDownloading(false);
      }, 1000);
    }
  }
  
  const getDocumentDownloadCall = async (groupId) => {
    
    var url = '/api/dlms/downloadDocument';
    //console.log(loginInfo.token);
    return httpDownload.post(url, { "groupId": groupId }, {
      responseType: 'blob',
      headers: {
        "Authorization": "Bearer " + loginInfo.token
      }
    });
  }
  
  return (
    <>
      <LeftPageHeader
        subTitle="COMMON FORMATS"
        title="Nursing Home Version 1.0"
        intro={null}
        rightContent={
          <div className="d-flex flex-column gap-3 w-xxs-100 w-sm-fit-content ms-auto me-auto h-100 justify-content-center mt-2 mb-2">
            {/*
            <TextButton
              variant={"normal"}
              //onClick={}
              content={"Explore Data Elements"}
              className="button-width"
            />
            */}
            <IconTextButton
              className="reverse button-width text-center w-100 d-flex justify-content-center"
              icon={ICONS.download}
              onClick={handleAllFileDownload}
              variant="outline-clear"
              content={"Download all Resources"}
            />
          
          </div>
        }
      >
        <h2 className="public-title text-center mb-3">Use this Common Format to:</h2>
        <Row className="blue-text public-cards col-gap-2 row-gap-5">
          <Col className="" md={6}>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column align-items-start">
                <div className="d-flex flex-column flex-lg-row align-items-start gap-3">
                  <div className="number-bg align-items-center">
                    <div className="mb-1"><span className="displayXS semibold">1</span></div>
                  </div>
                  
                  <div className="">
                    <div className="text-start mb-2"><span className="public-card-header horizontal ">Collect Data</span></div>
                    <div className="public-card-content ">
                      <p>Use the Nursing Home Version 1.0 Common Format to gather safety event data from your providers using AHRQ-defined best practices.</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column gap-3 w-xs-100 w-md-fit-content h-100 justify-content-end ms-auto me-auto">
                  
                  <TextButton
                    variant={"normal"}
                    onClick={() => scrollTo("level1-1")}
                    content={"Learn More"}
                    className="button-width"
                  />
                  <IconTextButton
                    className="reverse button-width text-center w-100 d-flex justify-content-center"
                    icon={ICONS.download}
                    onClick={handleCollectFileDownload}
                    variant="outline"
                    content={"Download Resources"}
                  />
                
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col className="" md={6}>
            <Card className="h-100">
              <Card.Body className="d-flex flex-column align-items-start">
                <div className="d-flex flex-column flex-lg-row align-items-start gap-3">
                  <div className="number-bg align-items-center">
                    <div className="mb-1"><span className="displayXS semibold">2</span></div>
                  </div>
                  <div>
                    <div className="text-start mb-2"><span className="public-card-header horizontal ">Submit Data</span></div>
                    <div className="public-card-content ">
                      <p>Contribute to national learning about safety events by sharing that data to the PSOPPC using the Nursing Home Version 1.0 Common Format.</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-column gap-3 w-xs-100 w-md-fit-content h-100 justify-content-end ms-auto me-auto">
                  
                  <TextButton
                    variant={"normal"}
                    onClick={() => scrollTo("level1-2")}
                    content={"Learn More"}
                    className="button-width"
                  />
                  <IconTextButton
                    className="reverse button-width text-center w-100 d-flex justify-content-center"
                    icon={ICONS.download}
                    onClick={handleSubmitFileDownload}
                    variant="outline"
                    content={"Download Resources"}
                  />
                
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </LeftPageHeader>
      
      <CommonFormatsBody commonFormatsData={data} ref={sectionRefs} />
      <Feedback/>
    </>
  );
}

export default NursingHomeV1_0;